import moment from 'moment'

export const requestSample = {
    id: '',
    srNumber: '',
    product: '',
    customer: '',
    destination: '',
    scheduleProduct: '',
    address: '',
    isApproval: false,
    isApprovedRS: false,
    approvedBy : '',
    approvedByName: '',
    remark : '',
    isDelete: false,
    startDate : moment().format('YYYY-MM-DD'),
    dueDate: moment().format('YYYY-MM-DD'),
}

export const requestSampleDetail = {
    id: '',
    sampleRequestId: '',
    spec: '',
    qty: 0,
    UOM: '',
    sampleCostMT: 0,
    sampleCost: '',
    DG: false,
    courier : false,
    carrierCost: '',
    courierInformationNumber: '',
    paid : false,
    remark: ''
}

export const requestSampleGanttChart = {
    id: '',
    sampleRequestId: '',
    sequence: '',
    name: '',
    start: moment().format('YYYY-MM-DD'),
    end : moment().format('YYYY-MM-DD'),
}